import React, { useState, useRef, useEffect } from 'react';
import './ObligationCurrencySelector.scss';

const CURRENCY_OPTIONS = [
  { value: 'CLP', label: 'CLP' },
  { value: 'UF', label: 'UF' },
  { value: 'UTM', label: 'UTM' },
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
];

const ObligationCurrencySelector = ({ value = 'CLP', onChange, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedOption = CURRENCY_OPTIONS.find(opt => opt.value === value) || CURRENCY_OPTIONS[0];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (option) => {
    if (onChange) {
      onChange(option.value);
    }
    setIsOpen(false);
  };

  return (
    <div className="obligation-currency-selector" ref={dropdownRef}>
      <button
        type="button"
        className={`obligation-currency-selector__button ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        <span className="obligation-currency-selector__value">{selectedOption.label}</span>
        <svg
          className="obligation-currency-selector__arrow"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="#6b7280"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {isOpen && !disabled && (
        <div className="obligation-currency-selector__menu">
          {CURRENCY_OPTIONS.map((option) => (
            <div
              key={option.value}
              className={`obligation-currency-selector__option ${value === option.value ? 'selected' : ''}`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ObligationCurrencySelector;

